import { FC, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import styled, { css } from 'styled-components'
import { ContractsPath, MiPath } from '../../routes/path'
import { colorPallet } from '../../styles/colors'

export const MiNavbar: FC = () => {
  const [isHover1, setIsHover1] = useState(false)
  const [isHover2, setIsHover2] = useState(false)

  return (
    <Navbar expand="md" className="bg-body-tertiary miNavbar">
      <Container>
        <Navbar.Brand href={ContractsPath}>
          <StyledLogo src="/images/miproteger-logo.png" alt="Mi Proteger" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <div onMouseEnter={() => setIsHover1(true)} onMouseLeave={() => setIsHover1(false)}>
              <Nav.Link href={ContractsPath}>購入履歴</Nav.Link>
              <div css={animateBorderStyle({ isHover: isHover1, width: '80px' })}></div>
            </div>
            <div onMouseEnter={() => setIsHover2(true)} onMouseLeave={() => setIsHover2(false)}>
              <Nav.Link href={MiPath}>アカウント設定</Nav.Link>
              <div css={animateBorderStyle({ isHover: isHover2, width: '125px' })}></div>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

const StyledLogo = styled.img`
  width: 160px;
  height: auto;
  }
`

type AnimateProps = { isHover: boolean; width: string }

const animateBorderStyle = ({ isHover, width }: AnimateProps) => css`
  @media screen and (min-width: 768px) {
    content: '';
    display: block;
    position: absolute;
    width: ${() => (isHover ? width : '0')};
    height: 2px;
    background: ${colorPallet.primary};
    transition: 0.2s;
  }
`
